import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-web-ingestion-duplicates-modal',
  imports: [CommonModule],
  templateUrl: './web-ingestion-duplicates-modal.html',
  styleUrl: './web-ingestion-duplicates-modal.scss',
})
export class WebIngestionDuplicatesModal {
  activeModal = inject(NgbActiveModal);

  // L'array di conflitti che ci arriva dal backend
  @Input() duplicatesList: any[] = [];
  @Input() conflictType: string = 'PATH_CONFLICT';
  
  // Se true, significa che TUTTI gli URL inseriti sono risultati duplicati
  @Input() allDuplicates: boolean = false;

  resolveConflict(action: 'replace') {
    // Chiudiamo la modale restituendo l'azione scelta dall'utente al padre
    this.activeModal.close(action);
  }

}
